import InteractionAltitude from "../interaction/InteractionAltitude";
import InteractionLengthGround from "../interaction/InteractionLengthGround";
import InteractionLengthHorizontal from "../interaction/InteractionLengthHorizontal";
import InteractionLengthPlane from "../interaction/InteractionLengthPlane";
import InteractionLengthStraight from "../interaction/InteractionLengthStraight";
import InteractionLengthVertical from "../interaction/InteractionLengthVertical";
import MeasurementAltitude from "../measurement/MeasurementAltitude";
import MeasurementLengthStraight from "../measurement/MeasurementLengthStraight";
import MeasurementLengthGround from "../measurement/MeasurementLengthGround";
import MeasurementLengthPlane from "../measurement/MeasurementLengthPlane";
import MeasurementLengthVertical from "../measurement/MeasurementLengthVertical";
import MeasurementLengthHorizontal from "../measurement/MeasurementLengthHorizontal";
import MeasurementArea from "../measurement/MeasurementArea";
import InteractionArea from "../interaction/InteractionArea";
import MeasurementVolume from "../measurement/MeasurementVolume";
import InteractionVolume from "../interaction/InteractionVolume";
import {
  DitapMask,
  InteractionMove,
  InteractionRotate,
  InteractionScale,
} from "../../..";
import Utils from "./Utils";

/**
 * 측정 도구 모음 위젯. DitapViewer 내부적으로 생성되어 사용하는 위젯.</br>
 * A widget that collects measuring tools. The widget used internally by DitapViewer.
 *
 * @alias MeasurementToolPicker
 * @constructor
 *
 * @param {DitapViewer} viewer 사용할 Ditap Viewer 인스턴스.</br> The DitapViewer instance to use.
 * @param {object[]} measurementObjArray 표시 할 측정 도구 배열.</br> Array containing measuring tools to display
 *
 * @example
 * // 1. DitapViewer 생성 시 MeasurementToolPicker 생성 가능.
 * // measurementTools에 사용할 측정 도구 작성. 작성된 편집 도구들을 담은 측정 도구 모음 위젯 생성.
 * // 활성화 - 전체 활성화(measurementTools: true) 또는 부분 활성화(활성화 시킬 기능만 true)
 * // 비활성화 - false 또는 전달 안함
 * const viewer = new Ditap.DitapViewer("container", {
 *    measurementTools: {
 *        altitude: true,
 *        straight: true,
 *        ground: true,
 *        plane: true,
 *        vertical: true,
 *        horizontal: true,
 *        area: true,
 *        volume: true,
 *    }
 * });
 *
 * // 2. 단독으로 선언하여 활성화
 * const viewer = new Ditap.DitapViewer("ditapContainer");
 * // 사용할 측정 도구 모음 초기화
 * const measurementObjArray = [
 *    new Ditap.InteractionAltitude(),
 *    new Ditap.InteractionLengthStraight(),
 *    new Ditap.InteractionLengthGround(),
 *    new Ditap.InteractionLengthPlane(),
 *    new Ditap.InteractionLengthVertical(),
 *    new Ditap.InteractionLengthHorizontal(),
 *    new Ditap.InteractionArea(),
 *    new Ditap.InteractionVolume(viewer),
 * ];
 *
 * // 측정 도구 모음 생성
 * const measurementToolPicker = new Ditap.MeasurementToolPicker(viewer, measurementObjArray);
 */
class MeasurementToolPicker {
  constructor(viewer, measurementObjArray) {
    const container = viewer.toolPickerContainer;
    const mobileContainer = viewer.mobileBtnContainer;
    const that = this;

    this.isMobile = Utils.isBodyWidthLessThan600();

    // measurementObjArray 갯수에 따라 UI Class 설정
    let toolbarClass;
    const count = measurementObjArray.length + 1;
    if (count === 1) {
      toolbarClass = "width-one";
    } else if (count === 2) {
      toolbarClass = "width-two";
    } else if (count >= 3) {
      toolbarClass = "width-three";
    }

    const li = document.createElement("li");
    const button = document.createElement("button");
    const p = document.createElement("p");
    const p2 = document.createElement("p");
    button.classList.add("ditap-measurement-btn");
    p.classList.add("ditap-function-btn-img");
    p.classList.add("js-ditap-function-btn-img");
    p2.classList.add("ditap-btn-tooltip");
    p2.textContent = "측정";
    button.appendChild(p);
    button.appendChild(p2);
    li.appendChild(button);

    if (this.isMobile) {
      button.classList.add("ditap-mobile-btn");
      li.classList.add("ditap-func-btn-item");
      // mobileContainer.append(li);
      mobileContainer.querySelector(".js-position-measure").appendChild(li);
    } else {
      button.classList.add("ditap-toolbar-btn");
      li.classList.add("ditap-toolbar-right-item");
      container.appendChild(li);
    }

    const toolPopup = document.createElement("div");
    toolPopup.classList.add("mobile-tool-popup");

    const header = document.createElement("div");
    header.classList.add("tool-popup-header");

    const title = document.createElement("h2");
    title.classList.add("ditap-popup-title", "ditap-mobile-title");
    title.innerText = "측정";

    const btnWrap = document.createElement("div");
    btnWrap.classList.add("ditap-popup-btn-wrap");

    const closeBtn = document.createElement("button");
    closeBtn.classList.add("ditap-popup-close-btn");
    btnWrap.appendChild(closeBtn);
    header.appendChild(title);
    header.appendChild(closeBtn);

    toolPopup.appendChild(header);
    viewer.container.querySelector(".cesium-viewer").append(toolPopup);

    const funcList = document.createElement("div");
    funcList.classList.add("tool-popup-content");

    const ul = document.createElement("ul");
    ul.classList.add(toolbarClass);

    for (const obj of measurementObjArray) {
      const li2 = document.createElement("li");
      const button = document.createElement("button");
      const p1 = document.createElement("p");
      const p2 = document.createElement("p");

      const toolPicker = this.createToolPicker(viewer, obj);
      // 선택 버튼 엘리먼트
      obj.buttonElement = p1;

      li2.classList.add("ditap-function-card-list");
      button.classList.add("ditap-function-btn");
      button.classList.add(`ditap-${toolPicker.type}-btn`);
      p1.classList.add("ditap-function-btn-img");
      p2.classList.add("ditap-function-btn-title");
      p2.textContent = toolPicker.text;
      button.appendChild(p1);
      button.appendChild(p2);
      li2.appendChild(button);
      ul.append(li2);

      // 기능별 클릭 이벤트
      li2.addEventListener(
        "click",
        (this.toolPickerEvent = (e) => {
          that.close();
          toolPicker.event(e);
        })
      );

      if (this.isMobile) {
        funcList.appendChild(ul);
        ul.classList.add("tool-popup-list");
      } else {
        li.appendChild(ul);
        ul.classList.add(
          "ditap-card",
          "ditap-function-card",
          "js-ditap-function-card",
          "hide"
        );
      }
      toolPopup.appendChild(funcList);
    }

    closeBtn.addEventListener(
      "click",
      (this.closeEvent = (e) => {
        that.close();
      })
    );

    // 초기화 버튼 추가
    if (measurementObjArray.length > 0) {
      const li2 = document.createElement("li");
      const button = document.createElement("button");
      const p1 = document.createElement("p");
      const p2 = document.createElement("p");

      li2.classList.add("ditap-function-card-list");
      button.classList.add("ditap-function-btn");
      button.classList.add(`ditap-remove-btn`);
      p1.classList.add("ditap-function-btn-img");
      p2.classList.add("ditap-function-btn-title");
      p2.textContent = "초기화";
      button.appendChild(p1);
      button.appendChild(p2);
      li2.appendChild(button);
      ul.append(li2);

      li2.addEventListener(
        "click",
        (this.resetBtnEvent = () => {
          viewer.removeAllMeasurement();
          that.close();
        })
      );
    }

    button.addEventListener(
      "click",
      (this.measurementButtonEvent = () => {
        const callback = () => {
          viewer.clickToolbar(that);
        };
        viewer.offAllInterations(callback);
      })
    );

    this._toolPicker = li;
    this._toolList = ul;
    this._imgButton = p;
    this._mobilePopup = toolPopup;
    this._measurementButton = button;
    this._mobileToolList = funcList;
    this.mask = new DitapMask();
    this.createResizeEvent(viewer);
  }

  /*
   * 측정 도구 목록 표시하기 위한 요소.</br>
   * Display elements for the list of measurement tools.
   * @type {Element}
   */
  set toolPicker(toolPicker) {
    this._toolPicker = toolPicker;
  }
  get toolPicker() {
    return this._toolPicker;
  }

  /*
   * 측정 도구 목록 표시하기 위한 요소.</br>
   * Display elements for the list of measurement tools.
   * @type {Element}
   */
  set toolList(toolList) {
    this._toolList = toolList;
  }
  get toolList() {
    return this._toolList;
  }

  /*
   * 측정 도구 비활성화/활성화 버튼 요소.</br>
   * Disable/enable button element for measurement tools.
   * @type {Element}
   */
  set imgButton(imgButton) {
    this._imgButton = imgButton;
  }
  get imgButton() {
    return this._imgButton;
  }

  /*
   * 측정 도구모음 생성
   * @param {*} viewer
   * @param {*} obj
   * @returns
   */
  createToolPicker(viewer, obj) {
    let text;
    let type;
    let onInteraction;

    if (obj instanceof InteractionAltitude) {
      text = "고도";
      type = "altitude";
      onInteraction = () => {
        const measurementAltitude = new MeasurementAltitude({
          viewer: viewer,
        });
        obj.measurementAltitude = measurementAltitude;
        obj.on();
      };
    } else if (obj instanceof InteractionLengthStraight) {
      text = "직선거리";
      type = "straight";
      onInteraction = () => {
        const measurementLengthStraight = new MeasurementLengthStraight({
          viewer: viewer,
        });
        obj.measurementLengthStraight = measurementLengthStraight;
        obj.on();
      };
    } else if (obj instanceof InteractionLengthGround) {
      text = "지면거리";
      type = "ground";
      onInteraction = () => {
        const measurementLengthGround = new MeasurementLengthGround({
          viewer: viewer,
        });
        obj.measurementLengthGround = measurementLengthGround;
        obj.on();
      };
    } else if (obj instanceof InteractionLengthPlane) {
      text = "평면거리";
      type = "plane";
      onInteraction = () => {
        const measurementLengthPlane = new MeasurementLengthPlane({
          viewer: viewer,
        });
        obj.measurementLengthPlane = measurementLengthPlane;
        obj.on();
      };
    } else if (obj instanceof InteractionLengthVertical) {
      text = "수직거리";
      type = "vertical";
      onInteraction = () => {
        const measurementLengthVertical = new MeasurementLengthVertical({
          viewer: viewer,
        });
        obj.measurementLengthVertical = measurementLengthVertical;
        obj.on();
      };
    } else if (obj instanceof InteractionLengthHorizontal) {
      text = "수평거리";
      type = "horizontal";
      onInteraction = () => {
        const measurementLengthHorizontal = new MeasurementLengthHorizontal({
          viewer: viewer,
        });
        obj.measurementLengthHorizontal = measurementLengthHorizontal;
        obj.on();
      };
    } else if (obj instanceof InteractionArea) {
      text = "면적";
      type = "area";
      onInteraction = () => {
        const measurementArea = new MeasurementArea({
          viewer: viewer,
        });
        obj.measurementArea = measurementArea;
        obj.on();
      };
    } else if (obj instanceof InteractionVolume) {
      text = "체적";
      type = "size";
      onInteraction = () => {
        const measurementVolume = new MeasurementVolume({
          viewer: viewer,
        });
        viewer.ditapStorage.measurementVolume[
          measurementVolume.id
        ] = measurementVolume;
        obj.measurementVolume = measurementVolume;
        obj.on();
      };
    }

    const event = () => {
      if (
        (viewer.currentEvent instanceof InteractionScale ||
          viewer.currentEvent instanceof InteractionRotate ||
          viewer.currentEvent instanceof InteractionMove) &&
        viewer.currentEvent.selectObject
      ) {
        // 기존에 실행된 인터렉션 있을 경우 종료
        viewer.offAllInterations(onInteraction);
      } else {
        viewer.offAllInterations();
        onInteraction();
      }
    };

    return {
      text: text,
      type: type,
      event: event,
    };
  }

  /**
   * 측정 도구 모음 활성화.</br>
   * Activate the collection of measurement tools.
   */
  open() {
    this.toolPicker.classList.add("js-toolbar-on");
    this.imgButton.classList.add("on");

    this.mask.openMobile();
    if (this.isMobile) {
      this._mobilePopup.style.display = "block";
    } else {
      this._toolList.classList.remove("hide");
    }
  }

  /**
   * 측정 도구 모음 비활성화.</br>
   * Deactivate the collection of measurement tools.
   */
  close() {
    this.toolPicker.classList.remove("js-toolbar-on");
    this.imgButton.classList.remove("on");
    this.mask.closeMobile();

    if (this.isMobile) {
      this._mobilePopup.style.display = "none";
    } else {
      this._toolList.classList.add("hide");
    }
  }

  /**
   * 인스턴스 제거. </br>
   * Destroys the instance.
   */
  destroy() {
    this.removeEvent();
    this.toolPicker = undefined;
    this.toolList = undefined;
    this.imgButton = undefined;
    this._mobilePopup = undefined;
    this._measurementButton = undefined;
    this._mobileToolList = undefined;
    this.mask = undefined;
    this.isMobile = undefined;
  }

  /*
   * 윈도우 크기 조절 시 이벤트 생성.</br>
   * Create an event for window resize.
   * @param {DitapViewer} viewer 사용할 Ditap Viewer 인스턴스.</br> The DitapViewer instance to use.
   */
  createResizeEvent(viewer) {
    const container = viewer.toolPickerContainer;
    const mobileContainer = viewer.mobileBtnContainer;
    const that = this;

    const resizeOriginal = () => {
      // 윈도우의 현재 너비를 확인
      const currentIsMobile = Utils.isBodyWidthLessThan600();

      if (this.isMobile !== currentIsMobile) {
        if (currentIsMobile) {
          this.isMobile = true;
          this._measurementButton.classList.add("ditap-mobile-btn");
          this._measurementButton.classList.remove("ditap-toolbar-btn");

          this._toolPicker.classList.add("ditap-func-btn-item");
          this._toolPicker.classList.remove("ditap-toolbar-right-item");
          // mobileContainer.appendChild(this._toolPicker);
          mobileContainer
            .querySelector(".js-position-measure")
            .appendChild(this._toolPicker);

          this._toolList.classList.add("tool-popup-list");
          this._toolList.classList.remove(
            "ditap-card",
            "ditap-function-card",
            "js-ditap-function-card",
            "hide"
          );
          this._mobileToolList.appendChild(this._toolList);

          if (that._imgButton.classList.contains("on")) {
            this._mobilePopup.style.display = "block";
          }
        } else {
          this.isMobile = false;
          this._measurementButton.style.display = "flex";
          this._measurementButton.classList.remove("ditap-mobile-btn");
          this._measurementButton.classList.add("ditap-toolbar-btn");

          this._toolPicker.classList.add("ditap-toolbar-right-item");
          this._toolPicker.classList.remove("ditap-func-btn-item");
          container.appendChild(this._toolPicker);

          this._mobilePopup.style.display = "none";
          this._toolPicker.appendChild(this._toolList);
          this._toolList.classList.add(
            "ditap-card",
            "ditap-function-card",
            "js-ditap-function-card"
          );

          if (!that._imgButton.classList.contains("on")) {
            this._toolList.classList.add("hide");
            this._toolPicker.classList.remove("js-toolbar-on");
          }
          this._toolList.classList.remove("tool-popup-list");
        }
      }
    };
    this.resizeEvent = () => {
      resizeOriginal();
      setTimeout(resizeOriginal, 500);
    };
    window.addEventListener("resize", this.resizeEvent);
  }

  /**
   * 이벤트 제거.<br>
   * Remove the event registered on the window object.
   */
  removeEvent() {
    if (this.resizeEvent) {
      window.removeEventListener("resize", this.resizeEvent);
    }
    if (this.closeEvent) {
      window.removeEventListener("click", this.closeEvent);
    }
    if (this.toolPickerEvent) {
      window.removeEventListener("click", this.toolPickerEvent);
    }
    if (this.resetBtnEvent) {
      window.removeEventListener("click", this.resetBtnEvent);
    }
    if (this.measurementButtonEvent) {
      window.removeEventListener("click", this.measurementButtonEvent);
    }

    this.toolPickerEvent = undefined;
    this.resetBtnEvent = undefined;
    this.measurementButtonEvent = undefined;
    this.resizeEvent = undefined;
    this.closeEvent = undefined;
  }
}

export default MeasurementToolPicker;
